var exports = {
  "Q": "x112a1f60--2b1236--content",
};

module.exports = exports;
